export const admin_routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/admin/pages/Login"),
    meta: { title: "Login" },
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("@/views/admin/pages/Login"),
    meta: { title: "Logout" },
  },
  {
    path: "/",
    component: () => import("@/views/admin/Layout"),
    meta: {
      middleware: "advisor-auth",
      title: "Client Panel",
    },
    children: [
      {
        path: "",
        name: "AdminDashboard",
        component: () => import("@/views/admin/pages/Dashboard"),
        meta: { title: "Dashboard" },
      },
      {
        path: "clientmotorpolicy",
        name: "MotorPolicyListing",
        component: () =>
          import("@/views/admin/pages/ClientPartner/Policy/MotorIndex"),
        meta: { title: "Motor Policy" },
      },
      {
        path: "clientxmotorpolicy",
        name: "XMotorPolicyListing",
        component: () =>
          import("@/views/admin/pages/ClientPartner/Policy/XMotorIndex"),
        meta: { title: "X Motor Policy" },
      },
      {
        path: "clientHealthpolicy",
        name: "HealthPolicyListing",
        component: () =>
          import("@/views/admin/pages/ClientPartner/Policy/HealthIndex"),
        meta: { title: "Health Policy" },
      },
      {
        path: "clientTravelpolicy",
        name: "TravelPolicyListing",
        component: () =>
          import("@/views/admin/pages/ClientPartner/Policy/TravelIndex"),
        meta: { title: "Travel Policy" },
      },
      {
        path: "clientNonMotorpolicy",
        name: "NonMotorPolicyListing",
        component: () =>
          import("@/views/admin/pages/ClientPartner/Policy/NonMotorIndex"),
        meta: { title: "Non Motor Policy" },
      },
      {
        path: "clientLifepolicy",
        name: "LifePolicyListing",
        component: () =>
          import("@/views/admin/pages/ClientPartner/Policy/LifeIndex"),
        meta: { title: "Life Policy" },
      },
      {
        path: "clientOtherpolicy",
        name: "OtherPolicyListing",
        component: () =>
          import("@/views/admin/pages/ClientPartner/Policy/OtherIndex"),
        meta: { title: "Other Policy" },
      },

      // Renewals
      {
        path: "clientmotorrenewal",
        name: "MotorRenewalListing",
        component: () =>
          import("@/views/admin/pages/ClientPartner/Renewal/MotorIndex"),
        meta: { title: "Motor Renewal" },
      },
      {
        path: "clientxmotorrenewal",
        name: "XMotorRenewalListing",
        component: () =>
          import("@/views/admin/pages/ClientPartner/Renewal/XMotorIndex"),
        meta: { title: "X Motor Renewal" },
      },
      {
        path: "clientHealthrenewal",
        name: "HealthRenewalListing",
        component: () =>
          import("@/views/admin/pages/ClientPartner/Renewal/HealthIndex"),
        meta: { title: "Health Renewal" },
      },
      {
        path: "clientNonMotorrenewal",
        name: "NonMotorRenewalListing",
        component: () =>
          import("@/views/admin/pages/ClientPartner/Renewal/NonMotorIndex"),
        meta: { title: "Non Motor Renewal" },
      },
      {
        path: "clientLiferenewal",
        name: "LifeRenewalListing",
        component: () =>
          import("@/views/admin/pages/ClientPartner/Renewal/LifeIndex"),
        meta: { title: "Life Renewal" },
      },
      {
        path: "clientOtherrenewal",
        name: "OtherRenewalListing",
        component: () =>
          import("@/views/admin/pages/ClientPartner/Renewal/OtherIndex"),
        meta: { title: "Other Renewal" },
      },

      {
        path: "clientadvisor",
        name: "AdvisorListing",
        component: () =>
          import("@/views/admin/pages/ClientPartner/Advisor/Index"),
        meta: { title: "Advisor Listing" },
      },
    ],
  },
];
